import { useEffect, useRef, useState } from 'react';
import { servicosData } from '@/mocks/homeData';

export default function Servicos() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.1 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="servicos"
      ref={ref}
      className="bg-white py-28 md:py-36 lg:py-44 border-t border-black/[0.04]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight text-black tracking-tight text-center mb-14 md:mb-20">
          {servicosData.title}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {servicosData.items.map((item, i) => (
            <div
              key={item.name}
              className={`group bg-white border border-[#E8E8E8] p-8 md:p-10 hover:border-terracota/30 transition-all duration-500 ease-editorial ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-2xl text-terracota`} />
              </div>
              <h3 className="font-display text-lg md:text-xl font-normal text-black tracking-tight mb-4">
                {item.name}
              </h3>
              <p className="font-body text-sm font-light text-brand-gray-mid leading-[1.7]">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}